/* Columnas fijas del reporte. Las columnas de dia se agregan en tiempo
   de ejecucion a partir de las keys que devuelve el backend. */
export default [
  {
    key: "personal_name",
    label: "Conductor",
    stickyColumn: true,
    variant: "light",
    thStyle: { minWidth: "230px" },
  },
  {
    key: "regimen",
    label: "Régimen",
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "acumulado_anterior",
    label: "Acumulado",
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "meta_rango",
    label: "Meta",
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "programados_rango",
    label: "Program.",
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "tomados_rango",
    label: "Gozados",
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "vendidos_rango",
    label: "Vendidos",
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "ajustes_rango",
    label: "Ajustes",
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "saldo_actual",
    label: "Saldo",
    thClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "actions",
    label: "",
    thClass: "text-center",
    tdClass: "text-center",
  },
];
